import { IdentityProviderCreateMethodTypes } from "@enums/identity-provider-create-method-types";
import { SelectOption } from "@idw-types/common";

export const IDENTITY_PROVIDER_CREATE_METHOD_OPTIONS: Array<SelectOption> = [
    { 
        label: "Create a blank IDP Configuration, I will configure it myself",
        value: IdentityProviderCreateMethodTypes.USE_BLANK
    },
    {
        label: "Create a new IDP Configuration from an import file",
        value: IdentityProviderCreateMethodTypes.USE_IMPORT
    },
    {
        label: "Create a copy of an existing IDP Configuration",
        value: IdentityProviderCreateMethodTypes.USE_COPY
    }
];